import React, { useEffect, useState } from 'react'
import { App as Canvas } from './Canvas'
import {
  Interface,
  NavigationControls,
  ButtonTray,
  ModalContainer,
} from './Components/Interface'
import { Modal, Logo } from './Components/Blocks'
// import Modal from './Components/Interface/Modal'
import './assets/styles/App.css'
import styled from 'styled-components'
import { useSnapshot } from 'valtio'
import { state } from './context/store'
import { motion, AnimatePresence } from 'framer-motion'
import { websiteLogos } from './Components/textures'
import { productChoices } from './context/productChoices'
import './assets/styles/fonts.css'
// import './assets/styles/super-index.css'
import './assets/styles/enjoy-index.css'

const App = () => {


  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search)

    const currentSeat = queryParams.get('type')
    const currentRibs = queryParams.get('subtype')
    const isTest = queryParams.get('test')
    const currentMake = queryParams.get('make')
    const currentModel = queryParams.get('mdl')

    if (currentMake) {
      console.log(currentMake)
    } else {
      console.log('No Make URL params found')
    }
    if (currentModel) {
      console.log(currentModel)
    } else {
      console.log('No Model URL params found')
    }

    const normalize = (str) => str?.toLowerCase().replace(/[\s-]+/g, '')

    const setInitialModelsFromParams = () => {
      switch (currentSeat) {
        case 'motorcycle':
          state.current.initialChoices.threeDModel = 'motorcycle'
          state.current.initialChoices.type = { index: 0, name: 'Motorcycle' }
          break
        case 'atv':
          state.current.initialChoices.threeDModel = 'atv'
          state.current.initialChoices.type = { index: 1, name: 'ATVs' }
          break
        case 'ebike':
          state.current.initialChoices.threeDModel = 'ebike'
          state.current.initialChoices.type = { index: 2, name: 'eBikes' }
          break
        case 'scooter':
          state.current.initialChoices.threeDModel = 'scooter'
          state.current.initialChoices.type = { index: 3, name: 'Scooters' }
          break
        default:
          break
      }

      switch (currentRibs) {
        case 'standard':
          state.current.choices.ribs.selected.mode = 'no'
          break
        case 'ribbed':
          state.current.choices.ribs.selected.mode = 'single'
          break
        default:
          break
      }
    }

    if (currentSeat) {
      setInitialModelsFromParams()
    }

    if (currentMake) {
      const productData = productChoices.current.choices
      const typeIndex = state.current.initialChoices.type.index

      console.log('currentMake:', currentMake)
      console.log('typeIndex:', typeIndex)
      console.log('productData:', productData)
      console.log('productData[typeIndex]:', productData[typeIndex])

      if (typeIndex !== null && productData[typeIndex]) {
        const makes = productData[typeIndex].make

        const makeIndex = makes.findIndex(
          (m) => normalize(m[0]) === normalize(currentMake),
        )

        if (makeIndex !== -1) {
          state.current.initialChoices.make = {
            name: makes[makeIndex][0],
            index: makeIndex,
          }

          if (currentModel) {
            const models = makes[makeIndex][2]
            const modelIndex = models.findIndex(
              (m) => normalize(m[0]) === normalize(currentModel),
            )

            if (modelIndex !== -1) {
              state.current.initialChoices.model = {
                name: models[modelIndex][0],
                index: modelIndex,
              }
              state.current.initialChoices.confirmButtonText = 'Confirm your Bike Model'
            }
          }
        }
      }
    }

    // 🔑 Map make + model → indexes
    if (currentMake && currentModel) {
      const productData = productChoices.current.choices
      const typeIndex = state.current.initialChoices.type.index

      if (typeIndex !== null && productData[typeIndex]) {
        const makes = productData[typeIndex].make

        const makeIndex = makes.findIndex(
          (m) => normalize(m[0]) === normalize(currentMake),
        )

        console.log('Make index:', makeIndex)

        if (makeIndex !== -1) {
          state.current.initialChoices.make = {
            name: makes[makeIndex][0],
            index: makeIndex,
          }

          const models = makes[makeIndex][2]

          console.log('Models for selected make:', models)

          const modelIndex = models.findIndex(
            (m) => normalize(m[0]) === normalize(currentModel),
          )

          if (modelIndex !== -1) {
            state.current.initialChoices.model = {
              name: models[modelIndex][0],
              index: modelIndex,
            }
            state.current.initialChoices.confirmButtonText = 'Confirm your Bike Model'
          }
        }
      }
    }

    if (isTest) {
      state.current.modal.selectModel = false
      state.current.modal.open = false
    }
  }, [])




  return (
    <AnimatePresence>
      <Wrap id="app-container">
        <ModalContainer />
        <Canvas />
        <ButtonTray />
        <NavigationControls />
        <Interface />
        <Logo imgSrc={websiteLogos[state.current.logo]} />
      </Wrap>
    </AnimatePresence>
  )
}

export default App

const Wrap = styled.div`
  height: 100vh;
  width: 100vw;
  height: 100dvh !important;
  width: 100dvw !important;
  display: grid;
  grid-template-rows: 44vh 8vh 48vh;
  grid-template-columns: 1fr;
  position: relative;
  transition: all 0.3s ease-in-out;
  overflow: hidden;
  margin: 0;

  @media (min-width: 800px) {
    grid-template-rows: 70vh 8vh 22vh;
    gap: 16px;
  }
`
